/**
 * Set the current page
 *
 * Will trigger new search
 *
 * @param current Integer
 */
export default function setCurrent(current) {
  var _console;

  // eslint-disable-next-line no-console
  if (this.debug) (_console = console).log.apply(_console, ["Search UI: Action", "setCurrent"].concat(Array.prototype.slice.call(arguments)));

  this._updateSearchResults({
    current: current
  });
}